import http from "../services/httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/resources/";
const url = apiUrl + endPoint;

export async function getCustomerResources(equipmentIds) {
  if (equipmentIds === "") {
    equipmentIds = "None";
  }
  return await http.get(url + "equipment/" + equipmentIds);
}

export async function addResource(payload) {
  const resource = { ...payload };
  delete resource.daysToExtend;

  return await http.post(url + "add", resource);
}

export async function modifyService(payload, previousServiceId) {
  const service = { ...payload };
  delete service.daysToExtend;

  return await http.post(url + "modify/" + previousServiceId, service);
}

export async function extendService(payload, serviceId) {
  return await http.put(url + "extend/" + serviceId, payload);
}

export async function approveServiceDiscount(serviceId) {
  return await http.put(url + "approve/" + serviceId);
}

export async function changeInvoiceService(payload) {
  const updateData = { ...payload };
  delete updateData.equipmentId;

  return await http.put(url + "changeInvoiceService/", updateData);
}

export async function payInvoiceWithAccountBalance(invoiceId) {
  return await http.post(url + "payInvoiceWithAccountBalance/" + invoiceId);
}
